import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { BaseInfoActions } from '../Reducer/BaseInfoReducer';
import {
  FetchAdminCompanyMasterRows,
  IsAdminUser,
  MapCompanyRowsToCoList,
} from './adminCompanyMaster';

/**
 * 회사 목록 소스
 * - 일반 사용자: 로그인/GetInfo 시점 BaseInfo.companyInfo 유지
 * - ADMIN: GetComBasicR1 조회 후 BaseInfo.companyInfo 동기화(타 화면 반영)
 */
export default function useAdminCompanyMasterList(queryKeyPrefix = 'adminCompanyMaster') {
  const dispatch = useDispatch();
  const { userInfo, companyInfo } = useSelector((state) => state.BaseInfo);
  const isAdmin = IsAdminUser(userInfo);

  const loadAdminCompanyList = useCallback(async () => {
    if (!isAdmin) return [];
    const rows = await FetchAdminCompanyMasterRows(userInfo);
    if (rows.length > 0) {
      dispatch(BaseInfoActions.setCompanyInfo(rows));
    }
    return rows;
  }, [dispatch, isAdmin, userInfo]);

  useEffect(() => {
    if (!isAdmin || !userInfo?.userid) return;
    loadAdminCompanyList();
  }, [isAdmin, userInfo?.userid, queryKeyPrefix, loadAdminCompanyList]);

  const companyList = useMemo(
    () => (Array.isArray(companyInfo) ? companyInfo : []),
    [companyInfo]
  );

  const coList = useMemo(
    () => MapCompanyRowsToCoList(companyList),
    [companyList]
  );

  return {
    isAdmin,
    companyList,
    coList,
    loadAdminCompanyList,
  };
}

export { MapCompanyRowsToCoList };
